import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=7ec2efac&scoped=true"
import script from "./DetailDeposit.vue?vue&type=script&lang=js"
export * from "./DetailDeposit.vue?vue&type=script&lang=js"
import style0 from "./DetailDeposit.vue?vue&type=style&index=0&id=7ec2efac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2efac",
  null
  
)

export default component.exports